/**
 * L'Invoice project translations - Buttons section
 */

const buttons = {
  addCustomer: "Add Customer",
  cancel: "Cancel",
  save: "Save",
  saveChanges: "Save changes",
  saveAsDraft: "Save as draft",
  back: "Back",
  next: "Next",
  reviewAndSave: "Review & Save Invoice",
  send: "Send",
  edit: "Edit",
  editCustomerInfo: "Edit customer info",
  editBankingInfo: "Edit banking info",
  search: "Search Peppol Directory",
  // Upload actions
  uploadOptions: "Upload options",
  importInvoiceFromPdf: "Import Invoice from PDF",
  importInvoiceFromPdfDescription:
    "Upload a PDF invoice and we will extract the data for you. Review and save in just a few clicks.",
  bulkUploadFromTemplate: "Bulk upload from template",
  bulkUploadFromTemplateDescription:
    "Upload a completed Excel template to create invoices automatically.",
  uploadViaIntegration: "Upload via integration",
  uploadFile: "Upload file",
  newBadge: "NEW",
  // Bulk actions
  groupActions: "Group Actions",
  createEdoc: "Create e-doc",
  markAsPaid: "Mark as Paid",
  delete: "Delete",
  // E-Documents send actions
  sendViaPeppol: "Send e-doc",
  sendPeppolWithEmail: "Send e-doc + email",
  moveToEdit: "Move to edit",
  sendEinvoices: "Send E-invoices",
  // Create invoice actions
  createVatInvoice: "Create VAT Invoice",
  createSalesTaxInvoice: "Create Sales Tax Invoice",
  createExemption: "Create Exemption",
  clone: "Clone",
  addItem: "Add item",
  editItem: "Edit item",
  addBankingInfo: "Add banking info",
  addNewCustomer: "Add new customer",
  addNewTaxId: "Add new Tax ID",
  // Action menu items
  setAsDefault: "Set as default",
  unsetDefault: "Unset default",
  view: "View",
  history: "History",
  sendResponse: "Send response",
  restore: "Restore",
  sendViaEmail: "Send via email",
  manageProducts: "Manage products",
  addLine: "Add new line",
  // Preview step actions
  editInvoice: "Edit Invoice",
  saveInvoice: "Save Invoice",
  // Bank modal
  submit: "Submit",
  // Row actions
  downloadFile: "Download file",
  // Filters
  applyFilters: "Apply filters",
  clearFilters: "Clear filters",
  // Selection
  clearSelection: "Clear selection",
  // Actions
  continue: "Continue",
};

export default buttons;
